import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
    errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { getCompanyDocsRoute, onboardingPackagesListRoute, onboardingPartnersListRoute } from '@features/digitalOnboarding';
import { onboardPackagesList, payrollpartnersList } from '@features/digitalOnboarding/constants';

type useGetCompanyOnboardingDocsProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
    companyId: number
};

export const useGetCompanyOnboardingDocs = ({
    setErrorText = () => { },
    companyId
}: useGetCompanyOnboardingDocsProps) => {
    const {
        data: companyOnboardingDocs,
        isFetching: isLoadingCompanyOnboardingDocs,
    } = useQuery({
        queryKey: [onboardPackagesList, companyId],
        enabled: Boolean(companyId),
        queryFn: () => {
            return axiosInstance
                .get(getCompanyDocsRoute + `?company_id=${companyId}`)
                .then((res) => res.data);
        },
        onSuccess: (data) => {
            if (data.object) {
                setErrorText('');
            }
            if (data.status !== 200) {
                setErrorText(data.message);
            }
        },
        onError: () => {
            setErrorText(errorMessage);
        },
        refetchOnWindowFocus: false,
    });

    return {
        companyOnboardingDocs,
        isLoadingCompanyOnboardingDocs
    };
};
